export default function contains(root, n) {
  var node = n;
  while (node) {
    if (node === root) {
      return true;
    }
    node = node.parentNode;
  }

  return false;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_rc-util@4.3.1@rc-util/es/Dom/contains.js
// module id = 386
// module chunks = 0 1